/*
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 *  @author    Afternet <info@afternet.gr>
 *  @copyright 2022 Afternet
 *  @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */
import React, {useState} from 'react';
import {Link, useParams} from "react-router-dom";

const FilterExpand = (props) => {

    let params = useParams();

    const [open, setOpen] = useState(props.has_selected_part || false);

    function clickHundler(){
        setOpen(!open);
    }

    return (
        <div className={`filterdouble ${open ? "open" : ""} ${props.parts.length > 0 ? "" : "filterdouble--empty"} `}>
            <div className='filterdouble__header d-flex justify-content-between' onClick={clickHundler}>
                <div className='filterdouble__label'>{props.title}</div>
                {!open && <div className='filterdouble__icon'>+</div>}
                {open && <div className='filterdouble__icon'>-</div>}
            </div>
            {<div className='filterdouble__body'>
                {open && props.parts.length > 0 && props.parts.map( (part, index)=>(
                    <Link to={props.link.replace('slug', `${encodeURIComponent(part.slug)}`).replace('value', `${part.specs_slug}`)} className={`filter-result`} key={index}>
                        <div className='row extra-small-gutters align-items-center'>
                            <div className='col'>
                                <span className={`filter-result__label ${part.slug == params.part ? "active" : ""}`}>{part.part_title} {part.specs && <>({part.specs})</>}</span>
                            </div>
                            <div className='col-auto'>
                                <span className='filter-result__num'>{part.parts_count}</span>
                            </div>
                        </div>
                    </Link>
                ) )}
            </div>}

        </div>
    );
};

export default FilterExpand;
